// Editorial merchandising layer — curated collections are filter sets over the
// live catalogue (no separate data). Each renders on the Shop page via
// /shop?collection=<slug>. `match` filters products client-side; `sort` sets the
// default order (a shopper can still re-sort).
export const COLLECTIONS = [
  {
    slug: "the-spotters-picks", title: "The Spotters' Picks",
    subtitle: "Our highest-conviction, certified finds.",
    img: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=800&q=70",
    match: (p) => p.spotted_certificate?.passed && (Number(p.rating) || 0) >= 4.5, sort: "rating",
  },
  {
    slug: "recently-spotted", title: "Recently Spotted",
    subtitle: "Freshly inspected and just listed.",
    img: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&q=70",
    match: (p) => !!p.spotted_certificate?.passed, sort: "newest",
  },
  {
    slug: "best-rated", title: "Best Rated",
    subtitle: "What shoppers keep coming back to.",
    img: "https://images.unsplash.com/photo-1460353581641-37baddab0fa2?w=800&q=70",
    match: (p) => (Number(p.rating) || 0) >= 4, sort: "rating",
  },
  {
    slug: "under-2500", title: "Under ₹2,500",
    subtitle: "Certified quality that stays kind to your wallet.",
    img: "https://images.unsplash.com/photo-1603487742131-4160ec999306?w=800&q=70",
    match: (p) => Number(p.price || 0) < 2500, sort: "price_asc",
  },
  {
    slug: "bis-size-match", title: "BIS Size Match",
    subtitle: "Footwear you can size with confidence.",
    img: "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=800&q=70",
    match: (p) => p.category === "footwear", sort: "recommended",
  },
  {
    slug: "everyday-essentials", title: "Everyday Essentials",
    subtitle: "The reliable staples worth owning.",
    img: "https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=800&q=70",
    match: (p) => p.spotted_certificate?.passed && Number(p.price || 0) < 3500, sort: "recommended",
  },
  {
    slug: "made-in-india", title: "Made in India",
    subtitle: "Backing independent Indian makers.",
    img: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=800&q=70",
    match: () => true, sort: "recommended",
  },
];

export const collectionBySlug = (slug) => COLLECTIONS.find((c) => c.slug === slug);
